const instructors = [
  {
    name: "Holly L",
    photo: "https://www.eltschool.jp/wp-content/uploads/2024/10/teacher_holly.jpg",
    bio: "オックスフォード大学で日本語を学び、その後20年間にわたり、イギリスやヨーロッパの機関投資家に対して日本株の投資アドバイスを提供。金融業界を離れた後、ロンドン大学でコーポレートガバナンスとビジネス倫理の修士号を取得。英語教授法資格であるCELTAを持つESOL/EFL教師であり、ELTでのオンライン個別レッスンに加え、市民相談所や難民支援団体West London Welcomeでボランティアに従事。ビジネス英語や金融英語に加え、発音指導も得意とする。"
  },
  {
  name: "Tom S",
  photo: "https://www.eltschool.jp/wp-content/uploads/2024/10/teacher_tom.jpg",
  bio: "ケンブリッジ大学で英文学を学び首席で卒業。その後、JETプログラムの一環として日本の学校で英語を教える。イギリスの小学校教諭の資格を保有しており、生徒が自信を持ち、クリエイティブな思考を持って成長することの手助けを生きがいとする。また、アングリア・ラスキン大学で児童書イラストレーションの修士号を取得し、児童向けの絵本やイラストレーションの制作活も行い、子ども向けのレッスンを得意とする。"
  },
  {
    name: "Andrew B",
    photo: "https://www.eltschool.jp/wp-content/uploads/2024/10/teacher_andrew.jpg",
    bio: "オックスフォード大学で英文学の修士号を取得後、JFEホールディングス株式会社で海外で働くエグゼクティブの英語をサポートし、日本の大学で5年間教鞭をとる。その後、マンチェスター・ビジネス・スクールでMBAを修了し、証券会社にて日本株の機関投資家向け営業を担当。一般ビジネス英語から専門分野の英語、エグゼクティブやMBA学生への英語レッスンの経験を豊富に持つ。英語でのカンファレンスや講演会でのスピーチ、プレゼンテーションの準備、また海外 (特にイギリス) での生活や仕事に備えるためのエグゼクティブ向けのコーチングを得意とする。"
  },
  {
    name: "David P",
    photo: "https://www.eltschool.jp/wp-content/uploads/2024/10/teacher_david-p.jpg",
    bio: "ユニバーシティ・カレッジ・ロンドンを卒業後、ICAO認定の航空英語能力試験官として、世界各国の航空会社のパイロットや客室乗務員、航空管制官の業務英語能力を評価。その後、ラファ・ナダル・テニスアカデミーでESL（第二言語としての英語）部門の責任者を務め、多国籍の学生やコーチングスタッフ、テニスのプロ選手に対してESLプログラムを提供。その他にもGoogle、デロイト、三菱商事、住友商事といった有名企業のハイレベルなビジネスパーソンにも英語指導を行ってきた実績を持つ。"
  },
  {
    name: "Chris B",
    photo: "https://www.eltschool.jp/wp-content/uploads/2024/10/teacher_chris.jpg",
    bio: "オックスフォード大学でラテン語と古代ギリシャ語を学んだ後、政治と哲学を専攻。卒業後、ロンドンの大手広告代理店に勤務。その後、コンピュータープログラミングを学び、名古屋に拠点を置くアメリカ企業に入社して技術翻訳や英語教育に従事。東海学園大学で専任講師として英語を指導した後、ノッティンガム大学で現代言語（フランス語と日本語）のPGCE（教育資格）を取得し、カーディフ大学で日本研究のMPhil（修士号）を取得。その後は名古屋の東海高等学校でオーラルイングリッシュの責任者を務める。また、長年にわたり英検の面接官やライティングの採点者として活躍。英検対策やエッセイ添削、一般ビジネス英語を得意とし太極拳や空手、合気道を趣味に持つ。"
  },
  // 追加の講師データもここに記載できます。
];

export default instructors;

